<script setup>
defineProps({
  as: {
    type: [Object, String],
    default: 'button',
  },
  square: {
    type: Boolean,
    default: false,
  },
  insetFocus: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <component
    :is="as"
    :class="[{ rounded: !square }, insetFocus ? 'focus:ring-inset' : 'focus:ring-offset-2']"
    class="inline-flex items-center border border-transparent bg-red-600 px-3 py-2 font-bold text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-brand-blue-light">
    <slot />
  </component>
</template>
